import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { styles } from "./styles";
import TableComponent from "../../../components/tableList";
import { TABLES } from "../../../constants/table-columns";
import { SubAdmin } from "../../../interface/sub-admin-interface";
import { UseAppDispatch } from "../../../hooks/useAppDispatch";
import { adminBlockUnblock, getSubadmins } from "../services/action";
import { useAppSelector } from "../../../hooks/useAppSelector";
import TuneIcon from "@mui/icons-material/Tune";
import moment from "moment";
import Menus from "../../../components/form-controls/menu";
import {
  GLOBAL_DATE_FILTER_DATA,
  STATUS_DATA,
} from "../../../constants/filter.data";
import ButtonControl from "../../../components/form-controls/button/basic-button";
import { DateRangeIcon } from "@mui/x-date-pickers-pro";
import { useNavigate } from "react-router-dom";
import { ADD_SUB_ADMIN, SUB_ADMIN } from "../../../constants/routes/routes-path";
import ConfirmDialog from "../../../shared/dialogs/confirm-dialog";
import "../../../common/common-table.scss";
import { ClearIcon } from "../../../constants/images";
import { SearchBar } from "../../../components/form-controls/searchBar";
import BreadCrumb from "../../../components/form-controls/breadCrumb";

export default function SubAdminList() {
  const navigation = useNavigate();
  const childRef = useRef();

  function createData(
    _id: string,
    id: number | string,
    name: string,
    email: string,
    role: string,
    createdAt: string,
    isActive: boolean,
    avatar: string
  ) {
    return {
      _id,
      id,
      name,
      email,
      role,
      createdAt,
      isActive,
      avatar,
    };
  }

  const defaultDimensions = { width: "400px", height: "270px" };
  const dateDimensions = { width: "160px", height: "250px" };

  const filterData = GLOBAL_DATE_FILTER_DATA;
  const statusData = STATUS_DATA;
  const dispatch = UseAppDispatch();
  const queryParamData = {};
  const sortData = {};
  const [subAdmins, setList] = useState<SubAdmin[]>();
  const { data, count } = useAppSelector((state) => state.admins);
  const [searchText, setSearch] = useState("");
  const [toDate, setToDate] = useState<string>("");
  const [fromDate, setFromDate] = useState<string>("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>();
  const [selectedFilter, setFilter] = useState("all");
  const [isDate, setIsDate] = useState(false);
  const [dimensions, setDimensions] = useState(defaultDimensions);
  const [isCustomMenu, setCustomMenu] = useState(false);
  const [selectedDateType, setDateType] = useState<string>();
  const [selectedUser, setSelectedUser] = useState<SubAdmin>();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const { permissionData } = useAppSelector(
    (state) => state.userPermissionInfo
  );
  
  useEffect(() => {
    let from = moment(new Date()).subtract(7, "days").format("YYYY-MM-DD");
    let to = moment(new Date()).format("YYYY-MM-DD");

    let dateType = filterData.find((data) => data.key === "lastWeek");
    setDateType(dateType?.name);
    setFromDate(from);
    setToDate(to);
    fetchSubmins();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onRefresh = () => {
    fetchSubmins();
  };

  const fetchSubmins = (reset: boolean = false, sort = "", sortBy = "") => {
    let obj: any = {
      limit: rowsPerPage,
      page: page,
      search: "",
      toDate: "",
      fromDate: "",
    };

    if (selectedFilter !== "all" && !reset) {
      obj["isActive"] = selectedFilter === "active" ? true : false;
    }
   if (sort && sortBy) {
     obj["sort"] = sort;
     obj["sortBy"] = sortBy;
   }
    if (searchText && searchText.trim() !== "") {
      obj["search"] = searchText.toLowerCase();
    }
    if (fromDate && toDate) {
      obj["fromDate"] = fromDate;
      obj["toDate"] = toDate;
    }
    console.log(obj,"obj")
    const queryParams = {
      ...queryParamData,
      ...obj
    };

    function objToQueryString(obj: any) {
      var k = Object.keys(obj);
      var s = "?";
      for (var i = 0; i < k.length; i++) {
        s += k[i] + "=" + obj[k[i]];
        if (i !== k.length - 1) s += "&";
      }
      return s;
    }

    const params = objToQueryString(queryParams);
    setAnchorEl(null);

    if (obj["fromDate"] !== "" && obj["toDate"] !== "") {
      dispatch(getSubadmins(params));
    }
  };

  useEffect(() => {
    fetchSubmins();
  }, [fromDate, toDate, rowsPerPage, page, searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (data) {
      let subAdmins = data.map((item: any) => {
        let createdDate = moment(new Date(item?.createdAt)).format("LLL");
        let data = createData(
          item._id,
          item.id,
          item?.name?.first + " " + item?.name?.last,
          item?.email,
          item?.role?.title,
          createdDate,
          item.isActive,
          item?.avatar
        );
        return data;
      });
      setList(subAdmins);
    }
  }, [data]);

  const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsDate(false);
    setDimensions(defaultDimensions);
    setAnchorEl(event.currentTarget);
    setCustomMenu(false);
  };
  const onDate = (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsDate(true);
    setCustomMenu(false);
    setAnchorEl(event.currentTarget);
    setDimensions(dateDimensions);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectMenu = (menu: any, index: number) => {
    if (!isDate) {
      setFilter(menu.value);
    } else if (menu?.key === "custom") {
      const dimensions = { width: "800px", height: "700px" };
      setDimensions(dimensions);
      setCustomMenu(true);
    } else {
      let filterDateType = filterData[index]["key"];

      let fromDate = new Date();
      let toDate = new Date();
      let from = "";
      let to = "";

      // Today
      if (filterDateType === GLOBAL_DATE_FILTER_DATA[0]["key"]) {
        from = moment(fromDate).format("YYYY-MM-DD");
        to = moment(fromDate).format("YYYY-MM-DD");
        setFromDate(from);
        setToDate(to);

        setDateType(GLOBAL_DATE_FILTER_DATA[0]["name"]);
      }
      // yesterday
      if (filterDateType === GLOBAL_DATE_FILTER_DATA[1]["key"]) {
        from = moment(fromDate).subtract(1, "days").format("YYYY-MM-DD");
        to = moment(toDate).subtract(1, "days").format("YYYY-MM-DD");
        setDateType(GLOBAL_DATE_FILTER_DATA[1]["name"]);
        setFromDate(from);
        setToDate(to);
      }

      // last week
      if (filterDateType === GLOBAL_DATE_FILTER_DATA[2]["key"]) {
        from = moment(fromDate).subtract(7, "days").format("YYYY-MM-DD");
        to = moment(toDate).format("YYYY-MM-DD");
        setDateType(GLOBAL_DATE_FILTER_DATA[2]["name"]);
        setFromDate(from);
        setToDate(to);
      }
      // last month
      if (filterDateType === GLOBAL_DATE_FILTER_DATA[3]["key"]) {
        from = moment(fromDate)
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");

        to = moment(toDate)
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");

        setFromDate(from);
        setToDate(to);
        setDateType(GLOBAL_DATE_FILTER_DATA[3]["name"]);
      }

      // last year
      if (filterDateType === GLOBAL_DATE_FILTER_DATA[4]["key"]) {
        let date = new Date();
        // first day of year
        from = moment(new Date(date.getFullYear() - 1, 0, 1)).format(
          "YYYY-MM-DD"
        );

        // last day of year
        to = moment(new Date(date.getFullYear() - 1, 11, 31)).format(
          "YYYY-MM-DD"
        );
        // from = new Date()
        setDateType(GLOBAL_DATE_FILTER_DATA[4]["name"]);
        setFromDate(from);
        setToDate(to);
      }
    }
  };

  const onReset = () => {
    setFilter("all");
    fetchSubmins(true);
  };

  const onSubmit = () => {
    fetchSubmins();
  };

  const onCreate = () => {
    navigation(ADD_SUB_ADMIN.fullUrl);
  };

  const onApplyFilter = () => {};

  const onCancel = () => {
    setAnchorEl(null);
  };
  const handleView = (id: string) => {
    navigation(`/sub-admin/view/${id}`);
  };
  const setCalenderValue = (from: any, to: any) => {
    let fromDate = moment(new Date(from)).format("YYYY-MM-DD");
    let toDate = moment(new Date(to)).format("YYYY-MM-DD");
    setFromDate(fromDate);
    setToDate(toDate);

    let fromDateDisplay = moment(new Date(from)).format("ll");
    let toDateDisplay = moment(new Date(to)).format("ll");

    setDateType(fromDateDisplay + "-" + toDateDisplay);
  };

  const openDialog = () => {
    (childRef.current as any).openDialog();
  };

  const onBlockUnBlock = (confirm: boolean) => {
    if (confirm) {
      if (selectedUser) {
        let body = {
          blockUnblockReason: "",
          isActive: selectedUser.isActive ? false : true,
          id: selectedUser._id,
        };
        dispatch(adminBlockUnblock(body, "", onRefresh));
      }
    }
  };

  const actionClick = (action: any, item: any) => {
    setSelectedUser(item);
    if (action === "edit") {
      navigation("/sub-admin/edit-user/" + item._id);
    } else if (action === "deactivate" || action === "activate") {
      openDialog();
    }
  };

  const handleRequestSort = (sortingKey:string,orderBy:string) => {
    console.log(sortingKey, orderBy, "sort");
       fetchSubmins(false, orderBy, sortingKey);
  }
  return (


    <div className="table-wrapper">
      <div className="heading-wrapper">
        <BreadCrumb
          showMultipleLink={false}
          mainLink={SUB_ADMIN.fullUrl}
          mainLabel={"Sub Admin Management"}
        />
        <div className="table-heading-btn">
          <Box
            sx={styles.search}
            onClick={(event: any) => {
              onDate(event);
            }}
          >
            <Box
              component="input"
              placeholder={selectedDateType}
              readOnly
              sx={styles.input}
            />
            <DateRangeIcon sx={styles.icon} />
          </Box>
          {
            //@ts-ignore
            permissionData["SUB_ADMINS"]?.includes("ADD") ? (
              <button className="action-click" onClick={onCreate}>
                Create
              </button>
            ) : (
              ""
            )
          }
        </div>
      </div>
      <div className="table-content">
        <Box sx={styles.searchAndFilter}>
          <SearchBar
            setSearch={setSearch}
            searchText={searchText}
            placeholderText="Search by Sub Admin ID, Name, Email ID"
          />

          <Box sx={styles.buttonStyle}>
            {selectedFilter !== "all" ? <Box sx={styles.dot} /> : null}
            <IconButton
              disableRipple
              id="icon-button"
              onClick={handleClickFilter}
              aria-describedby={"simple-popover"}
            >
              <TuneIcon sx={styles.iconColor} />
            </IconButton>

            <Menus
              menus={isDate ? filterData : statusData}
              value={selectedFilter}
              onClose={() => {}}
              anchorOrigin={() => {}}
              id={"simple-popover"}
              key={anchorEl ?? ""}
              anchorEl={anchorEl}
              handleClose={handleClose}
              selectMenu={selectMenu}
              onReset={onReset}
              onSubmit={onSubmit}
              onApplyFilter={onApplyFilter}
              onCancel={onCancel}
              setCalenderValue={setCalenderValue}
              label={!isDate ? "Sub Admin Status" : ""}
              showButton={!isDate ? true : false}
              isDropDown={isDate ? false : true}
              showList={isDate ? true : false}
              customMenu={isCustomMenu}
              dimensions={dimensions}
              selectedDateType={selectedDateType}
              menuWidth="500px"
            />
          </Box>
        </Box>

        {subAdmins && (
          <TableComponent
            dataSource={subAdmins}
            tableColumns={TABLES.SUB_ADMIN}
            actionClick={actionClick}
            onRowsChange={(value: number) => {
              setRowsPerPage(value);
            }}
            onPageChange={(value: number) => {
              setPage(value);
            }}
            handleRequestSort={handleRequestSort}
            total={count}
            handleView={handleView}
            //@ts-ignore
            showEdit={permissionData["SUB_ADMINS"]?.includes("EDIT")}
            //@ts-ignore
            showStatus={permissionData["SUB_ADMINS"]?.includes("STATUS")}
          />
        )}
        <ConfirmDialog
          title={
            selectedUser?.isActive
              ? "Deactivate Sub Admin"
              : "Activate Sub Admin"
          }
          message={
            selectedUser?.isActive
              ? "Are you sure you want to deactivate this sub admin?"
              : "Are you sure you want to activate this sub admin?"
          }
          cancelButtonText={"Cancel"}
          confirmButtonText={"Confirm"}
          logoutUser={onBlockUnBlock}
          ref={childRef}
        />
      </div>
    </div>
  );
}
